import React from 'react';
import { TextField, MenuItem } from '@mui/material';

/**
 * The only zones a location may be on (sc-6515), stored as Rails zone names.
 * Mirrors webhook-server's `Location::SUPPORTED_TIMEZONES` — keep the two
 * identical (both are pinned by tests). Arizona is separate from Mountain
 * because it doesn't observe DST.
 */
export const TIMEZONE_OPTIONS = [
  { label: 'Eastern', value: 'Eastern Time (US & Canada)' },
  { label: 'Central', value: 'Central Time (US & Canada)' },
  { label: 'Mountain', value: 'Mountain Time (US & Canada)' },
  { label: 'Mountain – Arizona (no DST)', value: 'Arizona' },
  { label: 'Pacific', value: 'Pacific Time (US & Canada)' },
] as const;

export const DEFAULT_TIMEZONE = 'Central Time (US & Canada)';

interface TimezoneSelectProps {
  value: string | undefined;
  onChange: (timezone: string) => void;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
}

export const TimezoneSelect: React.FC<TimezoneSelectProps> = ({ value, onChange, size, fullWidth }) => (
  <TextField
    select
    size={size}
    fullWidth={fullWidth}
    label="Timezone"
    value={value ?? ''}
    onChange={e => onChange(e.target.value)}
    helperText="Changes apply to the next scheduled digest."
  >
    {TIMEZONE_OPTIONS.map(opt => (
      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
    ))}
  </TextField>
);
